import React, { useEffect, useState } from "react";
import style from "./index.module.scss";
import { Spin } from "antd";
import useRequest from "../../../../../../Utils/useRequest";
import axios from "axios";
import classNames from "classnames";

interface DocViewerProps {
    src: string;
    className?: string;
}

export default function DocViewer({ src, className }: DocViewerProps) {
    const [frameLoading, setFrameLoading] = useState(false);

    useEffect(() => setFrameLoading(true), [src]);

    const [url] = useRequest(
        async () => {
            if (!src.includes("/wps/")) return src;
            const request = axios.create();
            return request.get(src).then(res => res.data.data.link);
        },
        {},
        [src]
    );

    if (!url) return null;

    return (
        <div className={classNames(style.root, className)}>
            <Spin
                spinning={frameLoading}
                size="large"
                tip="正在加载文件，请稍等">
                <iframe
                    key={url}
                    onLoad={() => setFrameLoading(false)}
                    className={style.iframe}
                    src={url}
                />
            </Spin>
        </div>
    );
}
